<form class="datasource-form" [formGroup]="form">
  <app-row>
    <app-field [label]="'Фильтры, от которых зависит'">
      <p-multiSelect
        formControlName="dependsOn"
        display="chip"
        placeholder="Выберите фильтры"
        [options]="otherFilters"
        optionLabel="label"
        optionValue="id"
        [showClear]="true"
        [class.loading]="loading"
      />
    </app-field>
  </app-row>

  <p-tabView>
    <p-tabPanel header="Api получения значений">
      <datasource-form
        [form]="frontControl"
        [sourceTypes]="frontSourceTypes"
        [dependsOnValue]="form.controls.dependsOn.value"
      ></datasource-form>
    </p-tabPanel>

    <p-tabPanel *ngIf="frontControl.controls.type.value !== types.Local" header="Back">
      <button
        pButton
        type="button"
        class="copy-button p-button-success"
        [label]="'Скопировать из Источника данных'"
        [size]="'small'"
        (click)="onCopyDataToBack()"
      ></button>

      <datasource-form [form]="backControl" [sourceTypes]="backSourceTypes"></datasource-form>
    </p-tabPanel>
  </p-tabView>
</form>
